/** Environment, resolved and validated once at module load. */

function trimSlash(url: string) {
  return url.replace(/\/+$/, "");
}

const rawBase = import.meta.env.VITE_API_URL?.trim() || "https://api.rocketeer.uk";
const useDevProxy = import.meta.env.DEV && import.meta.env.VITE_DEV_PROXY === "true";

/**
 * The production Turnstile site key. A site key is public by design — it ships
 * in the page markup either way — so it lives here rather than depending on a
 * build-time variable being set correctly in the hosting dashboard. The *secret*
 * key is the sensitive half and stays on the API.
 *
 * Override with `VITE_TURNSTILE_SITE_KEY`, or set it to `off` to render no
 * widget at all (useful locally, where an API with no TURNSTILE_SECRET_KEY
 * skips verification entirely).
 */
const DEFAULT_TURNSTILE_SITE_KEY = "0x4AAAAAAA8oc5NHC21r5BAF";

const rawSiteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim();
const turnstileDisabled = ["off", "none", "false", "disabled"].includes(
  (rawSiteKey ?? "").toLowerCase(),
);

export const env = {
  /** Origin-relative when proxied in dev, absolute otherwise. */
  apiBase: useDevProxy ? "/__api" : trimSlash(rawBase),
  apiOrigin: trimSlash(rawBase),
  turnstileSiteKey: turnstileDisabled ? "" : rawSiteKey || DEFAULT_TURNSTILE_SITE_KEY,
  termsVersion: import.meta.env.VITE_TERMS_VERSION?.trim() || "2026-04-01.1",
  isDev: import.meta.env.DEV,
} as const;

export const turnstileEnabled = env.turnstileSiteKey.length > 0;

/**
 * Sent when there is no widget to solve. Only an API with no
 * TURNSTILE_SECRET_KEY accepts it; a deployed API answers `turnstile_failed`.
 */
export const TURNSTILE_DEV_TOKEN = "dev-turnstile-token";
